import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export interface IContasAPagarPendente {
  totalPendente: number;
  vencimento: string;
  bancoOrigem: string;
}

export interface IRetornoObterContasAPagarPendentes {
  totalPaginas: number;
  valorTotalPendente: number;
  valorTotalPendenteDoDiaDeHoje: number;
  pendentes: IContasAPagarPendente[];
}

export const ObterContasAPagarPendentes = async (CurrentPage: number) => {
  const { token } = obterParametrosDaURL();

  try {
    let URL = `/obter-contas-a-pagar-pendentes?CurrentPage=${CurrentPage}&Limit=${10}`

    const { data } = await api.get<IRetornoObterContasAPagarPendentes>(
      URL, { headers: { token }}
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível obter o resumo de documentos de contas a pagar pendentes"
    );
  }
};